import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=4dda75b0&scoped=true&"
import script from "./AppNotification.vue?vue&type=script&lang=js&"
export * from "./AppNotification.vue?vue&type=script&lang=js&"
import style0 from "./AppNotification.vue?vue&type=style&index=0&id=4dda75b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda75b0",
  null
  
)

export default component.exports